import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
    // 问卷调查列表
    questionnaireList(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire/list',
            type: 'get',
            params: params
        })
    },
    //   问卷调查修改
    questionnaireAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //   问卷调查删除
    questionnaireDel(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire/del',
            type: 'post',
            params: params
        })
    },
    //   问卷调查记录列表
    questionnaireRecord(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-user/record',
            type: 'get',
            params: params
        })
    },
    //   问卷调查记录详情
    questionnaireDetail(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-user/detail',
            type: 'get',
            params: params
        })
    },
    //   问卷调查问题列表
    questionnaireTopicList(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-topic/list',
            type: 'get',
            params: params
        })
    },
    //   问卷调查问题修改
    questionnaireTopicAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-topic/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 问卷调查问题删除
    questionnaireTopicDel(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-topic/del',
            type: 'post',
            params: params
        })
    },
    // 问卷调查问题答案列表
    questionnaireAnswerList(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-answer/list',
            type: 'get',
            params: params
        })
    },
    // 问卷调查问题答案修改
    questionnaireAnswerAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-answer/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 问卷调查问题答案删除
    questionnaireAnswerDel(data) {
        const params = data
        return request({
            url: urlParams + '/questionnaire-answer/del',
            type: 'post',
            params: params
        })
    },
    // 投票记录管理
    voteRecord(data) {
        const params = data
        return request({
            url: urlParams + '/vote-record/record',
            type: 'get',
            params: params
        })
    },
    // 投票列表
    voteList(data) {
        const params = data
        return request({
            url: urlParams + '/vote/list',
            type: 'get',
            params: params
        })
    },
    // 投票添加
    voteAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/vote/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 投票删除
    voteDel(data) {
        const params = data
        return request({
            url: urlParams + '/vote/del',
            type: 'post',
            params: params
        })
    },
    // 投票推荐
    voteRecommend(data) {
        const params = data
        return request({
            url: urlParams + '/vote/recommend',
            type: 'post',
            params: params
        })
    },    
    // 投票列表
    voteAnswerList(data) {
        const params = data
        return request({
            url: urlParams + '/vote-answer/list',
            type: 'get',
            params: params
        })
    },
    // 投票修改
    voteAnswerAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/vote-answer/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 投票删除
    voteAnswerDel(data) {
        const params = data
        return request({
            url: urlParams + '/vote-answer/del',
            type: 'post',
            params: params
        })
    },
    // 公告列表
    noticeList(data) {
        const params = data
        return request({
            url: urlParams + '/notice/list',
            type: 'get',
            params: params
        })
    },
    // 公告修改新增
    noticeAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/notice/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 公告删除
    noticeDel(data) {
        const params = data
        return request({
            url: urlParams + '/notice/del',
            type: 'post',
            params: params
        })
    },
    // 公告推荐
    noticeRecommend(data) {
        const params = data
        return request({
            url: urlParams + '/notice/recommend',
            type: 'post',
            params: params
        })
    },
    // 公告紧急
    noticeUrgent(data) {
        const params = data
        return request({
            url: urlParams + '/notice/urgent',
            type: 'post',
            params: params
        })
    },
    // 公告启用禁用
    noticeUpdateStatus(data) {
        const params = data
        return request({
            url: urlParams + '/notice/updateStatus',
            type: 'post',
            params: params
        })
    },
    // 活动列表
    activityList(data) {
        const params = data
        return request({
            url: urlParams + '/activity/list',
            type: 'get',
            params: params
        })
    },
    // 活动修改新增
    activityAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/activity/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    // 活动删除
    activityDel(data) {
        const params = data
        return request({
            url: urlParams + '/activity/del',
            type: 'post',
            params: params
        })
    },
    // 活动推荐
    activityRecommend(data) {
        const params = data
        return request({
            url: urlParams + '/activity/recommend',
            type: 'post',
            params: params
        })
    },
    activityEnableStatus(data) {
        const params = data
        return request({
            url: urlParams + '/activity/enableStatus',
            type: 'post',
            params: params
        })
    },
    // 活动记录
    activityRecordList(data) {
        const params = data
        return request({
            url: urlParams + '/activity-record/list',
            type: 'get',
            params: params
        })
    },
    // 公告发送通知
    sendNotice(data) {
        const params = data
        return request({
            url: urlParams + '/send-message/notice',
            type: 'post',
            params: params
        })
    },
    // 活动发送通知
    sendActivity(data) {
        const params = data
        return request({
            url: urlParams + '/send-message/activity',
            type: 'post',
            params: params
        })
    },
    // 问卷调查发送通知
    sendQuestionnaire(data) {
        const params = data
        return request({
            url: urlParams + '/send-message/questionnaire',
            type: 'post',
            params: params
        })
    },
    // 投票发送通知
    sendVote(data) {
        const params = data
        return request({
            url: urlParams + '/send-message/vote',
            type: 'post',
            params: params
        })
    },    
}